/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useSelector } from "react-redux";
import Select from 'react-select';
import { getServicesFilter, getServicesFilterMany } from '../redux/FiltersSelector';
import { colourStylesSelect, themeSelect } from '../helpers';

interface Props {
  applyFilter: (data: any) => void;
  initialValues: Array<any>;
}

export const ServiceFilter: React.FC<Props> = ({applyFilter, initialValues}) => {
  const servicesChoices: Array<any> = useSelector(getServicesFilter) as Array<any>;
  const initialServicesValues: Array<any> = useSelector(getServicesFilterMany(initialValues)) as Array<any>;
  const [optionsSelect, setOptionsSelect] = React.useState(initialServicesValues)

  return (
    <div className='col-lg-4 py-4'>
      <h4>Servicios</h4>
      <Select
        styles={colourStylesSelect}
        theme={themeSelect}
        options={servicesChoices}
        placeholder="Seleccionar servicios"
        defaultValue={optionsSelect}
        value={optionsSelect}
        isClearable={true}
        isMulti={true}
        onChange={(option) => {
          let totalOptions = option.length
          if (totalOptions > 0 && option) {
            setOptionsSelect([...option]);
            // FILTRAR
            const servicesToSend = option.map((item: any) => item.value)
            if (servicesToSend) {
              applyFilter({services: servicesToSend})
            }
            
          } else {
            setOptionsSelect([]);
            applyFilter({services: []})
          }
        }}
      />
    </div>
  )
}

export default ServiceFilter;
